import { render, staticRenderFns } from "./AdminAnnouncementModal.vue?vue&type=template&id=eae4d93a&scoped=true&"
import script from "./AdminAnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae4d93a",
  null
  
)

export default component.exports